import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { EmptyTimeline } from '../../timeline/components/EmptyTimeline.jsx';
import ChatWorkspaceConversationLayout from '../layout/ChatWorkspaceConversationLayout.jsx';
import ChatWorkspaceSectionShell from '../layout/ChatWorkspaceSectionShell.jsx';

const firstTruthy = (...values) => values.find(Boolean);

/** Render the normal welcome projection with Project creation in the Composer position. */
export default function ChatWorkspaceProjectInitView(props) {
  const {
    contentMaxWidth,
    createProjectDisabled,
    handleCreateProject,
    isCompactLayout,
    resolvedProductName,
    resolvedUILabels,
    themeTokens,
  } = { createProjectDisabled: false, ...props };
  const labels = Object.assign({}, resolvedUILabels);
  const createProjectLabel = firstTruthy(labels.new_project_button, labels.create_project_button, '创建项目');

  const welcomeNode = (
    <div className="flare-workspace-ready-state flare-project-init-welcome">
      <div style={{ margin: '0 auto', maxWidth: contentMaxWidth, padding: 16, width: '100%' }}>
        <EmptyTimeline
          description={firstTruthy(labels.empty_state_description, '开始一个新对话。')}
          imageAlt={labels.empty_state_logo_alt ?? ''}
          imageUrl={labels.empty_state_logo_url ?? ''}
          logoLabel={labels.sidebar_logo_label}
          logoTag={labels.sidebar_logo_tag}
          themeTokens={themeTokens}
          title={firstTruthy(labels.empty_state_title, `欢迎使用 ${resolvedProductName}`)}
        />
      </div>
    </div>
  );
  const projectCreateNode = (
    <ChatWorkspaceSectionShell
      background={themeTokens.appBg}
      className="flare-project-create-dock-shell flare-staged-entry"
      contentMaxWidth={contentMaxWidth}
      padding={isCompactLayout ? '8px 12px 12px' : '10px 20px 18px'}
      style={{ '--flare-entry-stage': 2 }}
    >
      <button
        aria-label={createProjectLabel}
        className="flare-project-create-dock"
        disabled={createProjectDisabled}
        onClick={() => handleCreateProject?.()}
        style={{ background: themeTokens.panelBg, borderColor: themeTokens.divider, color: themeTokens.textPrimary }}
        type="button"
      >
        <PlusOutlined aria-hidden="true" />
        <span>{createProjectLabel}</span>
      </button>
    </ChatWorkspaceSectionShell>
  );

  return (
    <ChatWorkspaceConversationLayout
      background={themeTokens.appBg}
      canvasPanelNode={null}
      canvasWorkspaceFullscreenMode={false}
      composerNode={projectCreateNode}
      isCompactLayout={isCompactLayout}
      mainContentNode={welcomeNode}
      recommendationPanelNode={null}
      showCanvasPanel={false}
    />
  );
}
